export default __webpack_public_path__ + "static/media/AppStore.187512ae.webp";